import { useState } from "react";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { PageHeader } from "@/components/common/PageHeader";
import { useAuth } from "@/auth/useAuth";
import { QueueTab } from "./tabs/QueueTab";
import { TemplatesTab } from "./tabs/TemplatesTab";
import { AutoRulesTab } from "./tabs/AutoRulesTab";
import { BroadcastTab } from "./tabs/BroadcastTab";

export function NotificationsPage() {
  const { hasPermission } = useAuth();
  const canManageTemplates = hasPermission("notify.tpl");
  const canSend = hasPermission("notify.send");

  const tabDefs = [
    { key: "queue", label: "Журнал и очередь", show: true },
    { key: "templates", label: "Шаблоны", show: canManageTemplates },
    { key: "autorules", label: "Автоправила", show: canManageTemplates },
    { key: "broadcast", label: "Рассылка", show: canSend },
  ].filter((t) => t.show);

  const [activeKey, setActiveKey] = useState(tabDefs[0]?.key ?? "queue");

  return (
    <>
      <PageHeader title="Уведомления" subtitle="Журнал, шаблоны, автоправила и рассылки" />
      <Paper className="crm-workspace-panel crm-notifications" variant="outlined">
        <Tabs value={activeKey} onChange={(_, v) => setActiveKey(v)} variant="scrollable" scrollButtons={false}>
          {tabDefs.map((t) => (
            <Tab key={t.key} value={t.key} label={t.label} />
          ))}
        </Tabs>
        <Box className="crm-workspace-panel__body" p={3}>
          {activeKey === "queue" && <QueueTab />}
          {activeKey === "templates" && <TemplatesTab />}
          {activeKey === "autorules" && <AutoRulesTab />}
          {activeKey === "broadcast" && <BroadcastTab />}
        </Box>
      </Paper>
    </>
  );
}
